<template>
  <div>
    <section class="section-md section-shaped my-0 overflow-hidden">
      <div class="shape shape-style-1 shape-dark shape-skew">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="container pb-150">
        <span>&nbsp;</span>
        <div class="row text-center justify-content-center">
          <div class="col-lg-8">
            <h2 class="display-3 text-white" style="margin-top: 2.5rem">Integration software services </h2>
          </div>
          <div class="col-lg-6">
            <h4 class="text-white">Software and product development services</h4>
          </div>
        </div>
        <div class="text-center">
          <base-button type="primary" class="mt-4 bg-gradient-primary">
            <a href="#/contact-us" class="text-white"> Get in touch! </a>
          </base-button>
        </div>
      </div>
    </section>
    <section class="section section-sm TEAM">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col">
            <div class="">
              <img
                v-lazy="'./img/brand/brand-logo2.png'"
                class="lead img-fluid"
                width="50%"
                height="auto"
                style="margin-top: 3rem; display: block; margin-left: auto; margin-right: auto;"
              />
            </div>
            <p class="lead text-muted" style="text-align: justify"></p>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row justify-content-center">
          <div class="col">
            <p class="lead text-muted" style="text-align: justify">
              <b>The core of our company's business is customized software development. We carry out projects using our team as well as individual specialists dedicated exclusively to a given project. We cooperate 
              with our partners in leasing resources for a given project.
              The solutions proposed by our team allow for securing every area of the 
              IT systems, thus constituting a comprehensive system of IT protection 
              client's IT.</b>
            </p>
            <div class="offerDescription">
              <p class="lead text-muted" style="text-align: justify">
                <b>Software Engineering and S.I. based solutions:</b> Development of a web application for managing customers' financial security. 
                Development of a web application for estimating the cost of construction work.
                Provision of sports analytical data (API) - statistics, terms, conditions, object descriptions, etc.
              </p>
              <p class="lead text-muted" style="text-align: justify">
                <b>We perform integrations of existing IT applications and modify implemented production solutions in IT:</b> 
                Integration of monitoring systems and graphical engines for presentation of acquired data.
                Integration of cloud services and end devices (switch, router, firewall, server).
              </p>
              <p class="lead text-muted" style="text-align: justify">
                <b>We provide software support:</b> 
                Cloud services: AWS e.g. EC2, Lambda functions, SQS, SNS, S3, Cloudfront, Amplify, ElastiCache Microsoft Azure e.g. Service Bus, Event Hub, Step functions, Google e.g. Cloud Natural Language API, Compute Engine, Cloud Functions. 
                Databases: DynamoDb, RDS, MySQL, ElasticSearch, MongoDb, Firebase, MariaDb.
                Software: Office 365, Active directory, Grafana, Graylog, DataDog.
              </p>
              <p class="lead text-muted" style="text-align: justify">
                <b>We implement projects based on the latest cloud services::</b> 
                IBM, Amazon AWS, Microsoft Azure, Google
                We use artificial intelligence (GPT3, TensorFlow, IBM Watson).
                Contextual string clustering tool.
                Multilingual video transcription and translation tool.
              </p>
            </div>
            <p class="lead text-muted" style="text-align: center">
              <b>Extended offer in .pdf file:</b>
            </p>
            <div class="">
              <a href='https://pdf-open-sagaca.s3.amazonaws.com/Opis_us%C5%82ugi_programowanie_SAGACA._2023.pdf' target="_blank">
              <img
                v-lazy="'./img/pdflogodownload.png'"
                class="lead img-fluid"
                width="8%"
                height="8%"
                style="display: block; margin-left: auto; margin-right: auto;"
              />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Carousel from "./components/Carousel.vue";
import AWS from "aws-sdk";
import "dotenv/config";
export default {
  name: "home",
  components: { Carousel },
  data: function () {
    return {
      message: "",
      name: "",
      email: "",
    };
  },
  methods: {
    scrollToElement(options) {
      const transcriptionSection = this.$el.getElementsByClassName(
        "section section section-shaped my-0 overflow-hidden"
      )[0];
      if (transcriptionSection) {
        transcriptionSection.scrollIntoView(options);
      }
    },
    scrollToElement1(options1) {
      const matcherSection = this.$el.getElementsByClassName(
        "section section section-shaped my-0 overflow-hidden matcher"
      )[0];
      if (matcherSection) {
        matcherSection.scrollIntoView(options1);
      }
    },
    scrollToElement2(options2) {
      const teamSection = this.$el.getElementsByClassName("section section-sm TEAM")[0];
      if (teamSection) {
        teamSection.scrollIntoView(options2);
      }
    },
    scrollToElement3(options3) {
      const teamSection = this.$el.getElementsByClassName(
        "section section-sm Technologies"
      )[0];
      if (teamSection) {
        teamSection.scrollIntoView(options3);
      }
    },
    scrollToProducts(options4) {
      const teamSection = this.$el.getElementsByClassName(
        "section section section-shaped my-0 overflow-hidden PRODUCTS"
      )[0];
      if (teamSection) {
        teamSection.scrollIntoView(options4);
      }
    },
  },
};
</script>
